import { ComponentType } from "react"
import { Navigate, useLocation } from "react-router-dom"

import { useAuth } from "../hooks/useAuth"
import { routeConfig } from "interfaces/IUser"

type IPublicRoute = {
  component: ComponentType
}

export const PublicRoute = ({ component: RouteComponent }: IPublicRoute) => {
  const {
    user: { isAuthenticated, rules },
  } = useAuth()
  const location = useLocation()
  if (!isAuthenticated) {
    return <RouteComponent />
  }
  if (rules.some(rule => routeConfig.painelRules.includes(rule))) {
    return <Navigate to="/painel-de-admin/dashboard" state={{ from: location }} replace />
  }
  return <Navigate to="/painel-de-operador/abastecedor" />
}
